import React, { useState } from 'react'
import { Select } from 'antd'
import { useSelector } from 'react-redux'
import { userSelector } from '../../store/session'
import { getOrganization } from '../../services/dadata'

const ProviderSelector = ({ value = {}, onChange }) => {
  const { user } = useSelector(userSelector)
  const [options, setOptions] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const onSearch = (query) => {
    if (query && query.length >= 3) {
      setIsLoading(true)
      getOrganization(query, user.dadata_api_key)
        .then((response) => {
          if (response?.data && response?.data?.suggestions) {
            const newOptions = response.data.suggestions.map((item, index) => ({
              label: (
                <span>
                  <p>{`${item.value} (${item?.data?.inn})`}</p>
                  <p style={{ whiteSpace: 'break-spaces' }}>{item.data?.address?.value}</p>
                </span>
              ),
              value: `${item.value} (${item?.data?.inn})`,
            }))
            setOptions(newOptions)
          }
        })
        .catch(() => {
          // TODO: error handling
        })
        .finally(() => {
          setIsLoading(false)
        })
    }
  }

  const onChangeHandler = (selectedValue) => {
    onChange(selectedValue)
  }

  return (
    <Select
      value={value}
      loading={isLoading}
      onSearch={onSearch}
      defaultActiveFirstOption={false}
      filterOption={false}
      showSearch
      style={{ width: 300 }}
      placeholder="ИНН или название организации"
      notFoundContent="Введите несколько цифр ИНН или часть названия компании для получения списка компаний"
      onSelect={onChangeHandler}
      options={options}
      dropdownMatchSelectWidth={false}
    />
  )
}

export default ProviderSelector
